import { DropdownOptionModel } from './dropdown-option-model';

export const YEARS_WITH_EMPLOYER_OPTIONS: DropdownOptionModel<number>[] = [
  // save value of -1 must change based on start date (i.e. 0.25 for 3 months ago)
  { value: -1, display: '0-1' },
  // anything not '0-1' just save bottom of the range
  { value: 1, display: '1-2' },
  { value: 2, display: '2-3' },
  { value: 3, display: '3-4' },
  { value: 4, display: '4-5' },
  { value: 5, display: '5-10' },
  { value: 10, display: '10+' }
];
